import { createStore } from 'vuex'
import config from './storeConfig'

export default createStore(config)
